module.exports = __webpack_public_path__ + "static/media/x-icon.dea6a18a.svg";